<template>
  <div class="contact-popup-mobile">
    <div class="contact-popup-trigger" @click.stop="handleTriggerClick">
      <slot name="trigger"></slot>
    </div>
    <BaseActionSheet
      v-model:visible="actionSheetVisible"
      title=""
      :show-close="false"
      :actions="chatActions"
      @select="({ action }) => handleSelectChatType(action.value)"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import BaseActionSheet from '../ActionSheet.vue'
import { useQiyuChat } from '~/composables/useQiyuChat'

const { openQiyuChat } = useQiyuChat()
const actionSheetVisible = ref(false)

const chatActions = [
  { label: '解决方案咨询', value: 'scheme' },
  { label: '产品咨询', value: 'sales' },
  { label: '售后咨询', value: 'afterSales' },
]

/**
 * @description 点击触发按钮，显示 ActionSheet
 * @returns {void}
 */
const handleTriggerClick = () => {
  actionSheetVisible.value = true
}

/**
 * @description 选择客服类型并打开七鱼会话（移动端同时关闭 ActionSheet）
 * @param {'scheme'|'sales'|'afterSales'} type - 客服类型
 * @returns {void}
 */
const handleSelectChatType = (type) => {
  actionSheetVisible.value = false
  openQiyuChat({ type, from: 'chatbot-contact-popup' })
}
</script>

<style lang="scss" scoped>
.contact-popup-mobile {
  position: relative;
  display: inline-block;
  width: 100%;

  .contact-popup-trigger {
    width: 100%;
  }
}
</style>
